import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../styles/TopHeading.module.css";
import logo from "../imgs/neko-final.png";

export default function TopHeading() {
  return (
    <div className={styles.topColumn}>
      <Container>
        <Row className={styles.row}>
          <Col sm={6} className={styles.leftGrid}>
            <p className={styles.eyebrow}>FREELANCE WEB DEVELOPMENT STUDIO</p>
            <h1 className={styles.heading}>NEKO WEB STUDIOS</h1>
            <p className={styles.tagline}>
              We design and build fast, responsive business websites that
              turn visitors into customers &mdash; from first concept to
              launch.
            </p>
            <div className={styles.buttonBox}>
              <a href="tel:8120100041"><button className={styles.buttons} id={styles.black}>Call Us</button> </a>{' '}
              <a href="mailto:mathuresha@nekowebstudios.com"><button className={styles.buttons} id={styles.white}>Mail Us</button></a>
            </div>
          </Col>
          <Col sm={6} className={styles.imageCol}>
            <div className={styles.imageCard}>
              <svg
                viewBox="0 0 600 400"
                className={styles.blob}
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  fill="#b31a23"
                  d="M570,200C561.7,221.3,518.3,237,502,257C485.7,277,494.8,308.5,472,320C449.2,331.5,398.7,316.3,365,326C331.3,335.7,300,378.2,270,378C240,377.8,213.5,339.3,185,325C156.5,310.7,128.2,306.3,99,292C69.8,277.7,11.7,259,10,239C8.3,219,76,194.7,89,172C102,149.3,71.5,118.7,88,103C104.5,87.3,157.7,92.3,188,78C218.3,63.7,239.2,20.3,270,17C300.8,13.7,340,47,373,58C406,69,438.2,71.2,468,83C497.8,94.8,535,109.5,552,129C569,148.5,578.3,178.7,570,200Z"
                />
              </svg>
              <img src={logo} alt="Neko Web Studios logo" className={styles.imageContainer}/>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
